import React from 'react';
import {renderToStaticMarkup} from 'react-dom/server';

export type InvalidConnectionTargetFilterDefsProps = {
	/** id для url(#id) в attrs узла X6 */
	filterId: string;
};

/**
 * SVG filter: обесцвечивание + полупрозрачный красный слой по форме цели связи.
 * Разметка в JSX — единый источник; вставка в DOM графа в ensureInvalidConnectionTargetFilter.
 */
export function InvalidConnectionTargetFilterDefs({
	filterId,
}: InvalidConnectionTargetFilterDefsProps) {
	return (
		<defs>
			<filter
				id={filterId}
				x="-5%"
				y="-5%"
				width="110%"
				height="110%"
				colorInterpolationFilters="sRGB"
			>
				<feColorMatrix in="SourceGraphic" type="saturate" values="0" result="desat" />
				<feFlood floodColor="#ff3b30" floodOpacity="0.4" result="flood" />
				<feComposite in="flood" in2="desat" operator="in" result="tint" />
				<feMerge>
					<feMergeNode in="desat" />
					<feMergeNode in="tint" />
				</feMerge>
			</filter>
		</defs>
	);
}

/** Строка `<defs>...</defs>` для вставки в документ SVG графа X6 */
export function renderInvalidConnectionFilterDefs(filterId: string): string {
	return renderToStaticMarkup(<InvalidConnectionTargetFilterDefs filterId={filterId} />);
}
